import { apiErrorMessages } from './constants';
import { ErrorEnum } from './error.enum';
import { IErrorMessages } from './types';

export const getApiErrorMessages = (code?: ErrorEnum): IErrorMessages => {
  const messages = code !== undefined ? apiErrorMessages[code] : undefined;

  return messages ?? apiErrorMessages[ErrorEnum.NOT_FOUND]!;
};
